import React, { PureComponent } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Record } from "immutable"
import ReactTooltip from "react-tooltip"
import { NavLink } from "react-router-dom"

// helpers
import { shortenString } from "helpers/string.helper"
import { getRoutePath } from "routes"

// selectors
import { getWorkspaceRecord } from "selectors/workspace.selector"

class WorkspaceDetailSubmenu extends PureComponent {
  render() {
    const { workspace } = this.props

    if (!workspace) {
      return null
    }

    const hasWorkspaceTooltip = workspace.name.length >= 70
    const workspaceTooltipProps = hasWorkspaceTooltip
      ? { "data-tip": workspace.name, "data-for": "navigation-tooltip" }
      : {}

    return (
      <React.Fragment>
        <nav className="secondary-nav">
          <NavLink to={getRoutePath("workspace.list")}>Workspaces</NavLink>
          <FontAwesomeIcon className="chevron-icon" icon={["far", "chevron-right"]} />
          <a className="is-active has-ws-icon" {...workspaceTooltipProps}>
            <FontAwesomeIcon className="prefix-icon" icon={["fas", "code-branch"]} />
            {shortenString(workspace.name, 70)}
          </a>
        </nav>
        <ReactTooltip id="navigation-tooltip" getContent={dataTip => dataTip} place="bottom" />
      </React.Fragment>
    )
  }
}

WorkspaceDetailSubmenu.propTypes = {
  workspace: PropTypes.instanceOf(Record)
}

const mapStateToProps = (state, ownProps) => {
  const {
    match: {
      params: { id }
    }
  } = ownProps
  return {
    workspace: getWorkspaceRecord(state, id)
  }
}

export default connect(mapStateToProps)(WorkspaceDetailSubmenu)
